import qs from 'querystring'

import _ from 'underscore'
import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'

const emptyOrderListData = {
  page: {
    pageNum: 0,
    total: 0,
  },
  list: [],
}
const getOrderList = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
  // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/order/list'
  Api.get(url, {
    headers: {
      'X-Host': 'mall.order.user-orders',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      if (data.status == 6003) {
        return resolve(emptyOrderListData)
      }
      if (data.status != 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})
const getOrderDetail = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }

  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
  // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/order/detail'
  // url = 'https://yapi.sdyxmall.com/mock/91/api/order/detail/v2/test' // 组合商品-多包裹发货
  Api.get(url, {
    headers: {
      'X-Host': 'mall.order.detail.v2',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      // data = { status: 0, msg: 'success', data: { payOrderId: '2021082416364693723', orderId: '2021082416364698728', delivery: { name: '卢兵', address: '广东省深圳市南山区科兴科学园B栋科苑路15号科兴科学园B3栋16楼', postCode: '', phone: '16675523202' }, mobile: '16675523202', expressAmount: 500, endPayTime: 1629795106, endReceiptTime: 1630399684, deliveryTime: 1629794884, receiptTime: 0, payTime: 1629794207, totalPrice: 800, totalDiscountAmount: 0, epayAmount: 800, externalPayAmount: 0, nonCashAmount: 800, orderStatus: 4, payStatus: 1, payType: 0, payTypeName: '', virtualProduct: 0, express: { expressCompanyId: 2, expressCompanyName: '圆通', expressId: '32132123' }, createdAt: 1629794207, logisticsStatus: 0, packageType: 1, skuList: [{ skuId: 161690714, productId: 161650903, productName: '组合商品AAA', productType: 15, name: '不同供应商实物组合商品', imgUrl: 'https://mall.s.maizuo.com/aura/1f3db4ad075e2e6965c316e018b3ae8a.jpg', count: 1, price: 300, finalPrice: 300, marketPrice: 200, productSource: 0, exchangeCodes: null, deliveryExtInfo: [], thirdOrderExtInfo: { thirdOrderId: '', cinemaInfo: null, goodsInfo: null }, purchaseType: 0, action: { actionType: 7, actionData: '{"businessId":161650903,"param":1}' }, refundAmount: 0, labels: null, brandInfo: null, productModel: 1, orderId: '2021082416364698728' }, { skuId: 161659459, productId: 161629585, productName: '0329测试商品编辑', productType: 0, name: '规格2', imgUrl: 'https://mall.s.maizuo.com/aura/51405317cd5bcfe7ce12b7b303c482d6.png', count: 2, price: 11, finalPrice: 11, marketPrice: 0, productSource: 0, exchangeCodes: null, deliveryExtInfo: [], thirdOrderExtInfo: { thirdOrderId: '', cinemaInfo: null, goodsInfo: null }, purchaseType: 0, action: { actionType: 7, actionData: '{"businessId":161629585,"param":1}' }, refundAmount: 0, labels: [{ type: 1, text: '收货后1小时极速售后' }], brandInfo: null, productModel: 2, orderId: '2021082416364793298' }, { skuId: 161659470, productId: 161593952, productName: '测试商品-包邮编辑', productType: 0, name: '11', imgUrl: 'https://mall.s.maizuo.com/aura/35ae0c519968f25f8aaf7b026c0acad9.png', count: 1, price: 55, finalPrice: 55, marketPrice: 0, productSource: 0, exchangeCodes: null, deliveryExtInfo: [], thirdOrderExtInfo: { thirdOrderId: '', cinemaInfo: null, goodsInfo: null }, purchaseType: 0, action: { actionType: 7, actionData: '{"businessId":161593952,"param":1}' }, refundAmount: 0, labels: [{ type: 1, text: '收货后1小时极速售后' }], brandInfo: null, productModel: 2, orderId: '2021082416364793298' }, { skuId: 161680123, productId: 161643814, productName: '流氓兔', productType: 0, name: '白色', imgUrl: 'https://static.quanmaigo.com/i/u/63366fb765902633b6eda026dfb3a572.jpg', count: 2, price: 111, finalPrice: 111, marketPrice: 200, productSource: 0, exchangeCodes: null, deliveryExtInfo: [], thirdOrderExtInfo: { thirdOrderId: '', cinemaInfo: null, goodsInfo: null }, purchaseType: 0, action: { actionType: 7, actionData: '{"businessId":161643814,"param":1}' }, refundAmount: 0, labels: null, brandInfo: null, productModel: 2, orderId: '2021082416364793299' }], epayDetailList: [{ skuId: 161690714, epayType: 4, epayId: '26921629', epayCount: 0, epayAmount: 285 }, { skuId: 161690714, epayType: 3, epayId: '1223524', epayCount: 0, epayAmount: 15 }, { skuId: 2872, epayType: 4, epayId: '26921629', epayCount: 0, epayAmount: 500 }], packageList: [{ packageId: 3866138, orderId: '2021082416364793298', expressCompanyId: 2, expressCompanyName: '圆通', expressId: '32132123', logisticsStatus: 0, phone: '95554', expressCompanyCode: 'YTO', skuList: [{ masterSkuId: 0, skuId: 161659459, skuCount: 2 }, { masterSkuId: 0, skuId: 161659470, skuCount: 1 }], traceList: [{ acceptTime: '', acceptStation: '暂时无法追踪包裹，如需追踪，请前往\u003ca href="http://www.yto.net.cn" target="_blank"\u003e圆通\u003c/a\u003e官网查询快递单号。', remark: '' }], deliveryContactPerson: '', deliveryPhone: '' }], orderType: 0, expectDelivery: { minTime: 48, maxTime: 48 }, activeInfo: null, skuServiceList: [{ skuId: 161659459, canAfterSale: 0, serviceInfo: { serviceId: '2021082417190635268', serviceStatus: 6, skuNum: 2, serviceType: 1 } }, { skuId: 161680123, canAfterSale: 0, serviceInfo: null }], cardPostponeInfo: null, supplierId: 1270, orderServiceInfo: { canAfterSale: 0, serviceInfo: { serviceId: '2021082416480126645', serviceStatus: 6, skuNum: 0, serviceType: 0 } }, installment: null, supplierName: '', isChannelsOrder: 0, thirdOrder: null, repurchase: { isAddToCart: 1, action: null }, invoiceInfo: null, canInvoice: 0, canQuitGroup: 0, refundInfo: null, deliveryType: 0, deliveryExtInfo: [], hasExpressBtn: 0, platformType: 0, remark: '', businessInfo: null, businessType: 0, addressModifyStatus: 0, canModifyAddress: 0, orderModel: 1, skuOrderList: [{ skuId: 161690714, orderId: '2021082416364698728' }, { skuId: 161659459, orderId: '2021082416364793298' }, { skuId: 161659470, orderId: '2021082416364793298' }, { skuId: 161680123, orderId: '2021082416364793299' }] } }
      if (data.status != 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})
const cancelPayOrder = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  Api.get(`${COOKIECONSTANT.REQUEST_HOST}${query}`, {
    headers: {
      'X-Host': 'mall.order.cancel',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data.msg)
      }
      resolve(data)
    }, (e) => {
      reject(e)
    })
})
const confirmDelivery = queryData => new Promise((resolve, reject) => {
  Api.post(COOKIECONSTANT.REQUEST_HOST, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.order.confirm-delivery',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data.msg)
      }
      resolve(data)
    }, (e) => {
      reject(e)
    })
})
const getRecommendByOrder = queryData => new Promise((resolve, reject) => {
  Api.post(COOKIECONSTANT.REQUEST_HOST, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.product.order.recommend-list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      resolve(data)
    }, (e) => {
      reject(e)
    })
})
// 检查SKU是否下架
const checkProductStatus = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  Api.get(`${COOKIECONSTANT.REQUEST_HOST}${query}`, {
    headers: {
      'X-Host': 'mall.order.skulist',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})
// 提醒发货或手动刷新
const refreshOrder = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  Api.post(`${COOKIECONSTANT.REQUEST_HOST}${query}`, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.order.refresh-remind',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})

const getDeliveryInfo = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }
  let host = 'mall.order.logistic.query'
  if (queryData.serviceId) {
    host = 'mall.order.logistic.query.v2'
  }
  Api.get(`${COOKIECONSTANT.REQUEST_HOST}${query}`, {
    headers: {
      'X-Host': host,
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(new Error(data.msg))
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})
// 旧积分商城订单列表
const getOrderListOld = queryData => new Promise((resolve, reject) => {
  // let query = ''
  // if(!_.isEmpty(queryData)) {
  //     query = `?${qs.stringify(queryData)}`
  // }
  // Api.get('https://easy-mock.com/mock/59b219e6e0dc663341a20106/example/api/order/mall/list')
  Api.post(COOKIECONSTANT.REQUEST_HOST, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.order.mall.list',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })

    .then((data) => {
      if (data.status == 6003) {
        return resolve(emptyOrderListData)
      }
      if (data.status != 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})
// 旧积分商城订单详情
const getOrderDetailOld = queryData => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(queryData)) {
    query = `?${qs.stringify(queryData)}`
  }

  // Api.get(`https://easy-mock.com/mock/59b219e6e0dc663341a20106/example/api/order/mall/detail${query}`)
  Api.get(`${COOKIECONSTANT.REQUEST_HOST}${query}`, {
    headers: {
      'X-Host': 'mall.order.mall.detail',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})
const getOrderSimple = data => new Promise((resolve, reject) => {
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`

  Api.get(url, {
    headers: {
      'X-Host': 'mall.order.simple',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})

const getUserInvoice = () => new Promise((resolve, reject) => {
  const url = `${COOKIECONSTANT.REQUEST_HOST}`

  Api.get(url, {
    headers: {
      'X-Host': 'mall.after-sale.invoice-history',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})

const setOrderInvoice = options => new Promise((resolve, reject) => {
  const url = `${COOKIECONSTANT.REQUEST_HOST}`
  Api.post(url, JSON.stringify(options), {
    headers: {
      'X-Host': 'mall.after-sale.invoice-supplement',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})

const getOrderInvoiceDetail = orderId => new Promise((resolve, reject) => {
  const data = { orderId }
  let query = ''
  if (!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  const url = `${COOKIECONSTANT.REQUEST_HOST}${query}`

  Api.get(url, {
    headers: {
      'X-Host': 'mall.after-sale.invoice-detail',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})

const sendOrderInvoiceEmail = options => new Promise((resolve, reject) => {
  const url = `${COOKIECONSTANT.REQUEST_HOST}`
  Api.post(url, JSON.stringify(options), {
    headers: {
      'X-Host': 'mall.after-sale.invoice-send',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    },
      (e) => {
        reject(e)
      })
})
const getOrderDeleteStatus = option => new Promise((resolve, reject) => {
  const url = COOKIECONSTANT.REQUEST_HOST
  console.log(option)
  Api.post(url, JSON.stringify(option), {
    headers: {
      'X-Host': 'mall.order.del',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
    },
  }).then((data) => {
    if (data.status === 0) {
      return resolve(data.status)
    }
    return reject(data)
  }, (e) => {
    reject(e)
  })
})

const getFilmGbCode = queryData => new Promise((resolve, reject) => {
  Api.post(COOKIECONSTANT.REQUEST_HOST, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.film.order.gbcode',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})

const updateCodeStatus = queryData => new Promise((resolve, reject) => {
  console.log(queryData,'-queryData-');
  Api.post(COOKIECONSTANT.REQUEST_HOST, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.order.update-code-status',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})

const queryCodeStatus = queryData => new Promise((resolve, reject) => {
  Api.post(COOKIECONSTANT.REQUEST_HOST, JSON.stringify(queryData), {
    headers: {
      'X-Host': 'mall.order.query-code-status',
      'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || '',
    },
  })
    .then((data) => {
      if (data.status != 0) {
        return reject(data)
      }
      resolve(data.data)
    }, (e) => {
      reject(e)
    })
})

/* yeoman-template-point-1 */
export default {
  getOrderList,
  getOrderDetail,
  cancelPayOrder,
  confirmDelivery,
  getRecommendByOrder,
  checkProductStatus,
  refreshOrder,
  getDeliveryInfo,
  getOrderListOld,
  getOrderDetailOld,
  getOrderSimple,
  getUserInvoice,
  setOrderInvoice,
  getOrderInvoiceDetail,
  sendOrderInvoiceEmail,
  getOrderDeleteStatus,
  getFilmGbCode,
  updateCodeStatus,
  queryCodeStatus
  /* yeoman-template-point-2 */
}
